import LocalLanding from "./LocalLanding";
export default function LandingLisboa() {
    return (
        <LocalLanding
            city="Lisboa"
            canonicalSlug="remodelacoes-lisboa"
            hero="https://images.unsplash.com/photo-1774451607057-88ba4aa4ef99?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        />
    );
}
